export class RentalMovementImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  documentTypeCode: string = "";
  consecutive: number = 0;
  alterNumber: number | null = null;
  stateCode: number = 0;
  swBlock: boolean = false;
  documentDate: Date = new Date;
  invoiceDate: Date;
  swDontChargeInvoiceDay: boolean | null = null;
  costCenterCode: number = 0;
  documentTransporter: string = "";
  vehicleCode: number = 0;
  transportValue: number = 0;
  transportValuePay: number = 0;
  advertiser: string | null = null;
  printObservation: string | null = null;
  observation: string | null = null;
  orderConsecutive: number | null = null;
  articleCode: number = 0;
  storeCode: number = 0;
  quantity: number | null = null;
  clientValue: number | null = null;
  predevolutionQuantity: number | null = null;
  workshopQuantity: number | null = null;
  cleaningQuantity: number | null = null;
  cleaningValue: number | null = null;
  repairQuantity: number | null = null;
  repairValue: number | null = null;
  replacementQuantity: number | null = null;
  replacementValue: number | null = null;
  constructor(counter: number,
    companyId: number,
    branchId: number,
    documentTypeCode: string,
    consecutive: number,
    alterNumber: number | null,
    stateCode: number,
    swBlock: boolean,
    documentDate: Date,
    invoiceDate: Date,
    swDontChargeInvoiceDay: boolean | null,
    costCenterCode: number,
    documentTransporter: string,
    vehicleCode: number,
    transportValue: number,
    transportValuePay: number,
    advertiser: string | null,
    printObservation: string | null,
    observation: string | null,
    orderConsecutive: number | null,
    articleCode: number,
    storeCode: number,
    quantity: number | null,
    clientValue: number | null,
    predevolutionQuantity: number | null,
    workshopQuantity: number | null,
    cleaningQuantity: number | null,
    cleaningValue: number | null,
    repairQuantity: number | null,
    repairValue: number | null,
    replacementQuantity: number | null,
    replacementValue: number | null) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.documentTypeCode = documentTypeCode;
    this.consecutive = consecutive;
    this.alterNumber = alterNumber;
    this.stateCode = stateCode;
    this.swBlock = swBlock;
    this.documentDate = documentDate;
    this.invoiceDate = invoiceDate;
    this.swDontChargeInvoiceDay = swDontChargeInvoiceDay;
    this.costCenterCode = costCenterCode;
    this.documentTransporter = documentTransporter;
    this.vehicleCode = vehicleCode;
    this.transportValue = transportValue;
    this.transportValuePay = transportValuePay;
    this.advertiser = advertiser;
    this.printObservation = printObservation;
    this.observation = observation;
    this.orderConsecutive = orderConsecutive;
    this.articleCode = articleCode;
    this.storeCode = storeCode;
    this.quantity = quantity;
    this.clientValue = clientValue;
    this.predevolutionQuantity = predevolutionQuantity;
    this.workshopQuantity = workshopQuantity;
    this.cleaningQuantity = cleaningQuantity;
    this.cleaningValue = cleaningValue;
    this.repairQuantity = repairQuantity;
    this.repairValue = repairValue;
    this.replacementQuantity = replacementQuantity;
    this.replacementValue = replacementValue;
  }
}